import { useQuery } from 'react-query'
import { get } from 'framework/api/http'

import {
  buildSsccXmlListParams,
  SsccXmlListQueryVariables,
} from './useGetSsccXmlValidationList'

/* BDL20-3999: SSCC XMLs resent from the Fix pop-up (Retriggered SSCC XML tab) */
export const getSsccXmlRetriggeredList = async (queryData: any) => {
  const vars = queryData.queryKey[1] as SsccXmlListQueryVariables
  const res = await get(
    `/TnW/SsccXml/Retriggered?${buildSsccXmlListParams(vars).toString()}`,
  )
  return res.data
}

export const useGetSsccXmlRetriggeredList = (
  queryData: SsccXmlListQueryVariables,
) => {
  return useQuery(
    ['ssccXmlRetriggered', queryData],
    getSsccXmlRetriggeredList,
    {
      refetchOnWindowFocus: true,
      keepPreviousData: true,
    },
  )
}

export default useGetSsccXmlRetriggeredList
